// #region imports

// --- Angular
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

// --- 3rd Party
import { Observable, Subscription } from 'rxjs';

// --- HS Code
import { ToastModel, ToastEventModel } from '../../models';
import { AppToastService } from '../services/app-toast.service';

// #endregion

@Component({
  selector: 'hs-app-toast',
  templateUrl: './app-toast.component.html',
  styleUrls: ['./app-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppToastComponent {
  toasts$: Observable<ToastModel[]> | null;
  toastSubscription: Subscription | null;

  @Output() linkClicked = new EventEmitter<ToastEventModel>();

  constructor(private toastService: AppToastService) {
    this.toasts$ = null;
    this.toastSubscription = null;
  }

  ngOnInit() {
    this.toasts$ = this.toastService.toasts$;
  }

  hide(toast: ToastModel) {
    this.toastService.remove(toast);
  }

  onLinkClicked(toast: ToastModel): void {
    if (toast.eventName) {
      this.linkClicked.emit({
        eventTarget: toast.eventTarget,
        eventName: toast.eventName,
        eventPayload: toast.eventPayload } as ToastEventModel);
    }

    this.toastService.remove(toast);
  }
}
